import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { FHEDivider, FHEContainer } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import FormCraftsman from './Form/FormCraftsman';
import TableCraftsmanTickets from './Table/TableCraftsmanTickets';
import { getCraftsmanDetails, updateCraftsmanDetails, resetPassword } from '../../data/Craftsman/actions';

class CraftsmanDetail extends PureComponent {
    static propTypes = {
        getCraftsmanDetails: PropTypes.func.isRequired,
        updateCraftsmanDetails: PropTypes.func.isRequired,
        resetPassword: PropTypes.func.isRequired,
        craftsmanId: PropTypes.string.isRequired,
        match: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { location } = this.props;
        this.state = {
            loading: location.firstPage || !(location.state && location.state.fromAdd),
            error: null
        };
    }

    componentDidMount() {
        const { location } = this.props;
        if (location.firstPage || !(location.state && location.state.fromAdd)) this.getCraftsmanDetails();
    }
    getCraftsmanDetails = () => {
        const { getCraftsmanDetails, match } = this.props;
        this.setState({ loading: true, error: null });

        getCraftsmanDetails(match.params.craftsmanId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false
                });
            });
    };
    updateCraftsmanDetails = data => {
        const { updateCraftsmanDetails, craftsmanId } = this.props;
        return updateCraftsmanDetails(craftsmanId, data);
    };

    resetPassword = data => {
        const { resetPassword, craftsmanId } = this.props;
        return resetPassword(craftsmanId, data);
    };

    renderChildren = () => {
        const { profile, history, location } = this.props;
        const ticketListRights = profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('ticketList');
        return (
            <FormCraftsman
                type="update"
                sendDataFunc={this.updateCraftsmanDetails}
                resetPassword={this.resetPassword}
                renderOtherChildren={() => (
                    <Fragment>
                        {ticketListRights && (
                            <Fragment>
                                <FHEDivider title={Translator.translate(`generic.ticketing.table.title`)} />
                                <TableCraftsmanTickets needGetCraftsmanTicket={location.firstPage || !(location.state && location.state.fromAdd)} />
                            </Fragment>
                        )}
                    </Fragment>
                )}
            />
        );
    };

    render() {
        const { loading, error } = this.state;
        return <FHEContainer withBackIcon loading={loading} error={error} onClickFunc={this.getCraftsmanDetails} onRender={this.renderChildren} />;
    }
}

function mapStateToProps(state, props) {
    return {
        profile: state.data.user,
        craftsmanId: props.match.params.craftsmanId
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});
export default withRouter(
    renderEnvComponent(
        'scenes/Craftsman/details',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, { getCraftsmanDetails, updateCraftsmanDetails, resetPassword }),
                    dispatch
                )
        )(withStyles(styles, { withTheme: true })(CraftsmanDetail))
    )
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Craftsman/details.js